module.exports = __webpack_public_path__ + "static/media/logo.d94d2889.png";